module.exports = __webpack_public_path__ + "media/images/logos/cgf-01a90437bcc61ee29967de1569e040dc.png";